import { getEntitiesByFpIdOnboardingsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

const useOnboardings = (entityId: string) => {
  const { data: { data: onboardings } = { data: [] } } = useQuery({
    ...getEntitiesByFpIdOnboardingsOptions({ path: { fpId: entityId }, query: { pageSize: 1 } }),
  });

  return onboardings;
};

export default useOnboardings;
